/* eslint-disable import/prefer-default-export */
export const baseURL = process.env.REACT_APP_BASE_URL;
